import React from 'react';
import { EyeIcon, TagIcon, GaugeIcon, MessageCircleIcon, RefreshCwIcon, FlagIcon } from 'lucide-react';
const steps = [{
  label: '1 · Notice',
  body: 'Read what is figural here and now: body, voice, an interrupted contact, a polarity.',
  Icon: EyeIcon
}, {
  label: '2 · Name',
  body: 'Choose the family that fits: chairs and dialogue, exaggeration, movement, language, dreams and fantasy, group.',
  Icon: TagIcon
}, {
  label: '3 · Grade',
  body: 'Turn the Grade Dial — gentle, moderate or intense — to the safe emergency this client can use today.',
  Icon: GaugeIcon
}, {
  label: '4 · Offer',
  body: 'Exact offer lines that leave room for “no.” [Pause. Wait for a yes or a no.]',
  Icon: MessageCircleIcon
}, {
  label: '5 · Assimilate',
  body: 'Two or three closing questions, so the discovery lands before the session ends.',
  Icon: RefreshCwIcon
}, {
  label: 'On every card',
  body: 'A safety flag: when not to offer it, when to stop, when to refer or take it to supervision.',
  Icon: FlagIcon
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full border-b border-sand-dark bg-cream" data-id="element-273" data-mp="1f0pzpisdknic">
      <div className="mx-auto max-w-5xl px-5 py-16 text-center sm:py-20" data-id="element-274" data-mp="1jvlsil5frewi">
        <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-terra-deep" data-id="element-275" data-mp="1orkksjtvxh27">
          The mechanism
        </p>
        <h2 id="mechanism-heading" className="chalk-underline mt-3 font-display text-[28px] text-sage sm:text-5xl" data-id="element-276" data-mp="s4fuqbd6ttae">
          The Figure-to-Experiment Map
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-ink-soft sm:text-lg" data-id="element-277" data-mp="1154bvexvo9ri">
          An experiment can’t be scripted in advance — and it shouldn’t be.
          What you can prepare is the map. Every card in the library follows
          the same five steps, so when a figure emerges you already know the
          family, the grade and the words to offer it.
        </p>

        <ol className="mt-8 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-278" data-mp="1rr1b718g5heg">
          {steps.map(({
          label,
          body,
          Icon
        }, i) => <li key={label} className={`flex items-start gap-3 rounded-xl border px-4 py-3.5 ${i === steps.length - 1 ? 'border-terra/30 bg-terra/[0.06]' : 'border-sand-dark bg-white'}`} data-id="element-279" data-mp="21qs6v68qu2g4" data-mpi={i}>
              <span className={`mt-0.5 flex h-8 w-8 flex-none items-center justify-center rounded-full ${i === steps.length - 1 ? 'bg-terra/15 text-terra-deep' : 'bg-sage/10 text-sage'}`} data-id="element-280" data-mp="143johk41h9ic">
                <Icon className="h-4 w-4" aria-hidden="true" data-id="element-281" data-mp="qbn1fuh89pst" />
              </span>
              <span data-id="element-282" data-mp="q9k2um20eoch">
                <span className="block text-[11px] font-bold uppercase tracking-widest text-sage" data-id="element-283" data-mp="ldbovbzjt16w">
                  {label}
                </span>
                <span className="mt-1 block text-sm text-ink" data-id="element-284" data-mp="2wyucyy5p4d0u">{body}</span>
              </span>
            </li>)}
        </ol>
      </div>
    </section>;
}